module.exports = __webpack_public_path__ + "img/service-232.0cae78e2.png";